<img class="w-full" [src]="item.srcImg" />
<div class="md:flex flex-col text-center md:pt-12 pt-2">
  <div class="blue-500 md:text-6xl text-3xl pr-1">{{item.number}}</div>
  <div class="md:text-lg  mt-2">{{item.content}}</div>
</div>